import React from "react";
import "./passwordRules.css";

const rules = [
  { test: (pw) => pw.length >= 8, label: "At least 8 characters" },
  { test: (pw) => /[A-Z]/.test(pw), label: "One uppercase letter" },
  { test: (pw) => /[a-z]/.test(pw), label: "One lowercase letter" },
  { test: (pw) => /[0-9]/.test(pw), label: "One digit" },
  { test: (pw) => /[^A-Za-z0-9]/.test(pw), label: "One special character" },
];

export function validatePassword(password) {
  return rules.every((r) => r.test(password));
}

export function PasswordRules({ password }) {
  if (!password) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3, marginTop: 4 }}>
      {rules.map((r) => {
        const pass = r.test(password);
        return (
          <span
            key={r.label}
            className={`passwordRule${pass ? " is-pass" : ""}`}
          >
            {pass ? "✓" : "✗"} {r.label}
          </span>
        );
      })}
    </div>
  );
}
